import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ChdChipSetPresenter } from '@cp-produkte/cruise-hospitality-design';

/**
 * App-local renderer that lays `ChdChip`s out with the legacy `.spa-days`
 * container. Plugged into the chd chip-set slot via the backend provider,
 * e.g. `provideChdDxBackend({ chipSet: ChdChipSetSpaRenderer })`.
 */
@Component({
  selector: 'spa-chd-chip-set-renderer',
  imports: [NgTemplateOutlet],
  templateUrl: './chd-chip-set-spa-renderer.component.html',
  styleUrl: './chd-chip-set-spa-renderer.component.scss',
})
export class ChdChipSetSpaRenderer {
  protected readonly presenter = inject(ChdChipSetPresenter);
}
